import type { ProductType } from 'shared/products/domain//productType';
import type { LogData } from "./common/logData";
import type { ProductResponse } from './common/productResponse';
import type { CoilData } from './common/coilData';
import { useProductStore } from 'shared/products/stores/productStore';
import { useUpdateEntityApi } from '@/common/api/updateEntityApi';
import type { BulkData } from 'shared/products/domain/product';


export interface UpdateProduct {
  name: string;
  description: string;
  type: ProductType;
  color: string|null;
  externalCode: string | null;
  quality: string | null;
  logData: LogData | null;
  coilData: CoilData | null;
  bulkData: BulkData | null;
  productGroupId: string | null;
}

export interface UpdateProductResponse {
  ok: true;
  product: ProductResponse;
}

export function useUpdateProduct() {
  const store = useProductStore();

  return useUpdateEntityApi<UpdateProduct, UpdateProductResponse>({
    url: 'product',
    translate: (t) => t.products.actions.update,
    async processOk(response) {
      const json = await response.json() as ProductResponse;
      store.add(json);
      return {
        ok: true,
        product: json
      };
    },
  });
}


